export function formatDate (date) {
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

export function dateToQueryParam (date) {
  // toISOString() -> YYYY-MM-DDTHH:mm:ss.sssZ
  if (!date || !date.toISOString) return ''
  return date.toISOString().substr(0, 10)
}

export function dateFromQueryParam (dateQueryParam) {
  // dateQueryParam is expected to be ISOString format -> YYYY-MM-DDTHH
  if (!dateQueryParam) return null
  const parts = dateQueryParam.split(/\D/)
  return new Date(parts[0], parts[1] - 1, parts[2])
}
